import React from "react";
import { useHistory } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { i18n } from "../../translate/i18n";

const ShowTicketOpen = ({
  isOpen,
  handleClose,
  user,
  queue,
  ticketUuid,
  ticketId,
  ticketStatus,
}) => {
  const history = useHistory();

  const canNavigate = !!ticketUuid;

  const handleGoTo = () => {
    if (!canNavigate) return;
    handleClose && handleClose();
    history.push(`/tickets/${ticketUuid}`);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{i18n.t("showTicketOpenModal.title.header")}</DialogTitle>
      <DialogContent>
        {user !== undefined && queue !== undefined && (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.message")} <br />
            {`${i18n.t("showTicketOpenModal.form.user")}: ${user}`}
            <br />
            {`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}
            <br />
          </DialogContentText>
        )}
        {!user && (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.messageWait")} <br />
            {queue && `${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}
            <br />
          </DialogContentText>
        )}
        {(ticketId || ticketStatus) && (
          <DialogContentText style={{ marginTop: 8, fontSize: 12, opacity: 0.7 }}>
            {ticketId && `Ticket #${ticketId}`}
            {ticketStatus && ` · status: ${ticketStatus}`}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Fechar
        </Button>
        {canNavigate && (
          <Button
            onClick={handleGoTo}
            color="primary"
            variant="contained"
            startIcon={<OpenInNewIcon />}
          >
            Ir para o ticket
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ShowTicketOpen;
